export default {
  dialPlaceholder: 'Enter name or number',
} as const;
